<template>
  <div>
    <div v-if="loading" class="text-center">
      <spinner/>
    </div>
    <field-wrapper v-else label="Label" v-model="values.labels" :options="labelOptions" :multiple="true"
                   type="select" :close-on-select="false" description="Labels associated with the event."
                   :error="errors.labels"/>
  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import spinner from '@/components/shared/spinner'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'

  export default {
    components: {
      fieldWrapper,
      spinner
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'labelFilter',
    data () {
      return {
        labelOptions: FILTER_OPTIONS.labels,
        loading: FILTER_OPTIONS.labels.length === 0
      }
    }
  }
</script>
<style>
</style>
